import { render } from "./hub.vue?vue&type=template&id=432adb45&scoped=true"
import script from "./hub.vue?vue&type=script&lang=ts"
export * from "./hub.vue?vue&type=script&lang=ts"

import "./hub.vue?vue&type=style&index=0&id=432adb45&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-432adb45"

export default script